import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  actions: {
    createAnnouncement(_, payload) {
      return axiosIns.post('/announcement', payload)
    },
    getAnnouncemets() {
      return axiosIns.get('/announcement')
    },
    getAnnouncement(_, id) {
      return axiosIns.get(`/announcement/${id}`)
    },
    updateAnnouncement(_, { id, payload }) {
      return axiosIns.put(`/announcement/update/${id}`, payload)
    },
    updateRecurringAnnouncement(_, { id, payload }) {
      return axiosIns.put(`/announcement/update/recurring/${id}`, payload)
    },
  },
}
